import React from 'react';
import {
    Radio, Input, Button, Modal, Alert, message,
} from 'antd';
import { connect } from 'react-redux';
import {
    getVal, isNumber, isBoolean, get,
} from '../../../../../../shared/helpers';
import { updateBlemishReportRequest } from '../../../redux/actions/questions_actions/update_blemish_report.actions';
import { setLeadsCustomerValuationRequest } from '../../../redux/actions/set_customer_valuation.actions';

class BlemishQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            question_answer: this.getQuestionAnswer(getVal(this.props, `blemish_question_${this.props.questionNumber}`)),
        };
    }

    getQuestionAnswer({ value, customer_value }) {
        return value == null ? customer_value : value;
    }
    /**
     * Category 1 - Just confirm
     * Category 2 - Critical
     * Category 3 - just a text
     * Category 4 - price adjustment IS NOT USED
     * Category 5 - photo required IS NOT USED
     * Category 6 - buy anyway
     * Category 7 - buy anyway + text
     */

    /*
        * Category 1 - default behavior(We_wont_buy_false_anyway)
        * Category 2 - default behavior(Value_if_set_true_then_we_wont_buy_false),
        * if yes, we continue as normally, if no, blemish report status failed and we won't buy this bike.
        * Category 3 - default behaviour(We_wont_buy_false_anyway), leaving a text comment and we continue anyway
        * Category 4 - default behaviour(Value_if_set_true_then_price_adjustment_required), IS NOT USED
        * but also can be specific questions with Value_if_set_false_then_price_adjustment_required
        * Category 5 - default behaviour(Value_if_set_true_then_additional_photos_required) IS NOT USED
        * Category 6 - default behaviour(We_wont_buy_false_anyway)
        * Category 7 - default behaviour(We_wont_buy_false_anyway)
        * all questions, even critical, must have note
    */

    // info of possible handlers for questions
    /* valueHelpersArray = [
        "Value_if_set_true_then_we_wont_buy_false",
        "Value_if_set_true_then_we_wont_buy_true",
        "We_wont_buy_false_anyway",
        "Value_if_set_true_then_price_adjustment_required",
        "Value_if_set_false_then_price_adjustment_required",
        "Value_if_set_true_then_additional_photos_required"
    ]; */

    handleQuestionAnswer = (e) => {
        const answer = getVal(e, 'target.value');
        const { onChangeRadio, isEdit } = this.props;

        if (isBoolean(answer)) {
            // category 2 is critical, so user must approve that he is selecting critical answer
            if (this.blemish_question.category === 2) {
                if (this.blemish_question.value_helper) {
                    const critical_answer_on_false = this.blemish_question.value_helper === 'Value_if_set_true_then_we_wont_buy_false' && answer === false;
                    const critical_answer_on_true = this.blemish_question.value_helper === 'Value_if_set_true_then_we_wont_buy_true' && answer === true;

                    if (critical_answer_on_false || critical_answer_on_true) {
                        Modal.confirm({
                            title: 'Are you sure?',
                            content: 'By clicking the \'Confirm\' button, the status of this bike will change to \'Won\'t Buy\' due to the issue highlighted in the Blemish Report',
                            okText: 'Confirm',
                            okType: 'danger',
                            cancelText: 'Cancel',
                            onOk: () => {
                                this.setState({ question_answer: answer }, () => {
                                    this.props.updateBlemishReportRequest({
                                        lead_id: this.props.lead_id,
                                        question: `question_${this.props.questionNumber}`,
                                        updateValue: answer,
                                    });
                                });
                            },
                            onCancel: () => {
                                if (this.blemish_question.value === null) {
                                    this.setState({ question_answer: null });
                                } else {
                                    this.setState({ question_answer: !answer });
                                }
                            },
                        });
                    } else {
                        this.setState({ question_answer: answer }, () => {
                            this.props.updateBlemishReportRequest({
                                lead_id: this.props.lead_id,
                                question: `question_${this.props.questionNumber}`,
                                updateValue: answer,
                            });
                        });
                    }
                }
            } else if (this.blemish_question.position === 10) {
                if (answer === false) {
                    this.props.updateBlemishReportRequest({
                        lead_id: this.props.lead_id,
                        question: `question_${this.props.questionNumber}`,
                        updateValue: answer,
                    },
                    {
                        [`question_${this.props.questionNumber + 1}`]: { value: true },
                    });
                } else {
                    this.props.updateBlemishReportRequest({
                        lead_id: this.props.lead_id,
                        question: `question_${this.props.questionNumber}`,
                        updateValue: answer,
                    });
                }
            } else {
                this.props.updateBlemishReportRequest({
                    lead_id: this.props.lead_id,
                    question: `question_${this.props.questionNumber}`,
                    updateValue: answer,
                });
            }
        } else {
            message.error('Something went wrong during save question answer, please contact Admin');
        }
    };

    handleQuestionNote = (value) => {
        if (this.blemish_question.category === 3) {
            this.props.updateBlemishReportRequest({
                lead_id: this.props.lead_id,
                question: `question_${this.props.questionNumber}`,
                updateValue: true,
                note: value,
            });
        } else {
            this.props.updateBlemishReportRequest({
                lead_id: this.props.lead_id,
                question: `question_${this.props.questionNumber}`,
                note: value,
            });
        }
    };

    handleJustConfirmQuestionAnswer = (e) => {
        if (e) {
            if (e.target.name === 'confirm') {
                this.props.updateBlemishReportRequest({
                    lead_id: this.props.lead_id,
                    question: `question_${this.props.questionNumber}`,
                    updateValue: true,
                });
            }
        } else {
            message.error('Something went wrong during save question answer, please contact Admin');
        }
    };


    render() {
        const {
            onChangeInput,
            questionNumber,
            questionAnswer,
            isEdit,
        } = this.props;
        this.blemish_question = getVal(this.props, `blemish_question_${this.props.questionNumber}`);
        const defaultValue = this.blemish_question.note || this.blemish_question.customer_note;

        return getVal(this.blemish_question, 'question_for') && this.blemish_question.question_for.includes('Agent')
            ? (
                <div
                    className="question_container"
                    key={this.blemish_question._id}
                >
                    <div className="question_wrapper">
                        <span className="question_title">
                            {
                                this.props.is_lead_blemish_report_requires_approval
                                    ? `Thank you for answering your questions. Based upon your answers I need to get approval from my manager.
                                    If approved, I just need to make you aware it is essential the bike is not started on the day of collection
                                    as the oil must be completely cold, our drivers will be unable to carry out the physical assessment
                                    if the bike has been recently started.`
                                    : this.blemish_question.title
                            }
                        </span>

                        {
                            this.blemish_question.category !== 1
                        && this.blemish_question.category !== 3
                        && (
                            <Radio.Group
                            /* disabled={this.props.is_blemish_report_failed} */
                                name="photo required"
                                value={isBoolean(questionAnswer) ? questionAnswer : this.blemish_question.category === 2 ? this.state.question_answer : this.getQuestionAnswer(this.blemish_question)}
                                className="question_answer"
                                onChange={this.handleQuestionAnswer}
                            >
                                <Radio value={false}>No</Radio>
                                <Radio value>Yes</Radio>
                            </Radio.Group>
                        )
                        }
                    </div>

                    {
                        this.blemish_question.category !== 1
                    && (
                        isEdit ? (
                            <div>
                                <Input
                                    className="question_note"
                                    placeholder="Type note here. Use enter on the keyboard or click the send button to save answer"
                                    size="small"
                                    defaultValue={defaultValue}
                                    onChange={(e) => onChangeInput(e, `question_${questionNumber}`)}
                                />
                            </div>
                        ) : (
                            <div>
                                <Input.Search
                                    className="question_note"
                                    placeholder="Type note here. Use enter on the keyboard or click the send button to save answer"
                                    enterButton="Send"
                                    size="small"
                                    defaultValue={defaultValue}
                                    onSearch={this.handleQuestionNote}
                                />
                            </div>
                        )
                    )
                    }
                    {
                        this.blemish_question.we_wont_buy === true
                    && <Alert className="question-message" message="Sorry, cause of this issue we can't buy your bike" type="error" showIcon />
                    }

                    {
                        this.blemish_question.category === 1
                    && (
                        <Button
                        /* disabled={this.blemish_question.value} */
                            className="confirm_button"
                            onClick={this.handleJustConfirmQuestionAnswer}
                            htmlType="button"
                            type="primary"
                            name="confirm"
                        >
                            {this.blemish_question.value ? 'Confirmed' : 'Confirm'}
                        </Button>
                    )
                    }
                </div>
            )
            : getVal(this.blemish_question, 'question_for') && !this.blemish_question.question_for.includes('Agent')
                ? ''
                : <div className="question_container"><span className="failed-message">Something went wrong with question, please contact Admin.</span></div>;
    }
}


const mapStateToProps = (state, props) => {
    const propsObj = {
        currentUserId: get(state.App, 'App_content.user._id'),
        lead_id: getVal(state, 'Leads.Lead_profile.Lead_general.root_id'),
    };

    // ID of failed status in blemish report
    const blemish_report_failed_status_id = '5c6bb394b8292a22d8128dff';

    // check for failed status, if failed === true, then we wont buy this bike, and blemish report is finished
    propsObj.is_blemish_report_failed = getVal(state, 'Leads.Lead_profile.Lead_blemish_report.blemish_report.ref_lead_blemish_report_status') === blemish_report_failed_status_id;

    if (props && isNumber(props.questionNumber)) {
        propsObj[`blemish_question_${props.questionNumber}`] = getVal(state, `Leads.Lead_profile.Lead_blemish_report.blemish_report.questions.question_${props.questionNumber}`);

        if (props.questionNumber === 59) {
            propsObj.is_lead_blemish_report_requires_approval = getVal(state, 'Leads.Lead_profile.Lead_general.approval.blemish_report.requires_approval');
        }
    }

    return propsObj;
};

export default connect(mapStateToProps, { updateBlemishReportRequest, setLeadsCustomerValuationRequest })(BlemishQuestion);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_blemish_report/components/BlemishQuestion.js